import { doc, updateDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { generateEvaluatorDocId } from './utils';
import { EvaluatorUpdate } from './types';
import { checkAndAutoFinalizeEvaluators } from './autoFinalize';

export async function updateEvaluatorStatus(
  evaluatorId: string,
  userId: string,
  update: EvaluatorUpdate
): Promise<void> {
  const docId = generateEvaluatorDocId(evaluatorId, userId);
  const evaluatorRef = doc(db, 'evaluators', docId);

  await updateDoc(evaluatorRef, {
    [update.field]: update.value,
    updatedAt: new Date()
  });

  // Check for auto-finalization after status update
  await checkAndAutoFinalizeEvaluators(userId);
}